import { Abacus } from "core/Abacus.Core";

$.expr.filters.offscreen = function(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.x + rect.width < 0 ||
    rect.y + rect.height < 0 ||
    (rect.x > window.innerWidth || rect.y > window.innerHeight)
  );
};



// WEBPACK FOOTER //
// ./Javascript/jquery/FilterHelpers/FilterHelpers.js